/**
 * Alibaba PuHuiTi 3.0 55 Regular
 * Font Weight: 400
 */
export default {
    fontFamily: 'Alibaba PuHuiTi',
    aliases: ['AlibabaPuHuiTi', 'AlibabaPuHuiTi-Regular'],
    fontWeight: 400,
    fontStyle: 'normal',
    unitsPerEm: 1000,
    metrics: {
        ascender: 1060,
        descender: -340,
        lineGap: 0,
    },
    glyphs: {
        ' ': 257,
        '!': 361,
        '"': 405,
        '#': 600,
        '%': 821,
        '&': 640,
        '\'': 253,
        '(': 359,
        ')': 359,
        '*': 430,
        ',': 302,
        '-': 440,
        '.': 302,
        '/': 500,
        ':': 378,
        ';': 378,
        '?': 431,
        '@': 860,
        'B': 620,
        'C': 599,
        'D': 699,
        'F': 527,
        'G': 685,
        'H': 708,
        'J': 271,
        'K': 614,
        'L': 507,
        'M': 830,
        'N': 737,
        'P': 597,
        'R': 614,
        'S': 566,
        'T': 528,
        'V': 617,
        'W': 898,
        'X': 624,
        'Y': 594,
        'Z': 626,
        '[': 294,
        '\\': 510,
        ']': 294,
        '_': 500,
        '`': 346,
        'b': 635,
        'c': 497,
        'd': 635,
        'f': 349,
        'g': 636,
        'k': 518,
        'l': 286,
        'm': 921,
        'p': 635,
        'q': 636,
        'r': 379,
        's': 479,
        't': 337,
        'v': 526,
        'w': 828,
        'x': 516,
        'y': 527,
        'z': 506,
        '{': 299,
        '|': 183,
        '}': 299,
        ' ': 257,
        '¡': 357,
        '¦': 183,
        '§': 479,
        '¨': 346,
        '©': 806,
        'ª': 483,
        '«': 511,
        '­': 440,
        '®': 404,
        '¯': 346,
        '°': 363,
        '´': 346,
        '¶': 593,
        '·': 357,
        '¸': 346,
        'º': 445,
        '»': 511,
        '¼': 902,
        '½': 914,
        '¾': 902,
        '¿': 431,
        'Æ': 889,
        'Ç': 599,
        'Ð': 719,
        'Ñ': 737,
        'Ý': 594,
        'Þ': 597,
        'ß': 610,
        'æ': 926,
        'ç': 497,
        'ý': 527,
        'þ': 635,
        'ÿ': 527,
        'Ć': 599,
        'ć': 497,
        'Ĉ': 599,
        'ĉ': 497,
        'Ċ': 599,
        'ċ': 497,
        'Č': 599,
        'č': 497,
        'Ď': 699,
        'ď': 640,
        'Đ': 719,
        'đ': 635,
        'Ĝ': 685,
        'ĝ': 636,
        'Ğ': 685,
        'ğ': 636,
        'Ġ': 685,
        'ġ': 636,
        'Ģ': 685,
        'ģ': 636,
        'Ĥ': 708,
        'Ħ': 708,
        'Ĳ': 545,
        'ĳ': 536,
        'Ĵ': 271,
        'Ķ': 614,
        'ķ': 518,
        'ĸ': 518,
        'Ĺ': 507,
        'ĺ': 286,
        'Ļ': 507,
        'ļ': 286,
        'Ľ': 507,
        'ľ': 290,
        'Ŀ': 507,
        'ŀ': 291,
        'Ł': 507,
        'ł': 286,
        'Ń': 737,
        'Ņ': 737,
        'Ň': 737,
        'ŉ': 669,
        'Ŋ': 737,
        'Œ': 987,
        'œ': 917,
        'Ŕ': 614,
        'ŕ': 379,
        'Ŗ': 614,
        'ŗ': 379,
        'Ř': 614,
        'ř': 379,
        'Ś': 566,
        'ś': 479,
        'Ŝ': 566,
        'ŝ': 479,
        'Ş': 566,
        'ş': 479,
        'Š': 566,
        'š': 479,
        'Ţ': 528,
        'ţ': 337,
        'Ť': 528,
        'ť': 340,
        'Ŧ': 528,
        'ŧ': 337,
        'Ŵ': 898,
        'ŵ': 828,
        'Ŷ': 594,
        'ŷ': 527,
        'Ÿ': 594,
        'Ź': 626,
        'ź': 506,
        'Ż': 626,
        'ż': 506,
        'Ž': 626,
        'ž': 506,
        'ſ': 310,
        'Ə': 719,
        'ǎ': 608,
        'ǐ': 265,
        'ǒ': 614,
        'ǔ': 609,
        'ǖ': 609,
        'ǘ': 609,
        'ǚ': 609,
        'ǜ': 609,
        'Ǽ': 889,
        'ǽ': 926,
        'Ș': 566,
        'ș': 479,
        'Ț': 528,
        'ț': 337,
        'ʹ': 255,
        '͵': 255,
        ';': 378,
        '΄': 346,
        '΅': 346,
        'Ά': 670,
        '·': 357,
        'Έ': 628,
        'Ή': 779,
        'Ί': 346,
        'Ό': 765,
        'Ύ': 726,
        'Ώ': 765,
        'ΐ': 312,
        'Β': 620,
        'Γ': 507,
        'Ζ': 626,
        'Η': 708,
        'Κ': 614,
        'Λ': 617,
        'Μ': 830,
        'Ν': 737,
        'Π': 708,
        'Ρ': 597,
        'Σ': 596,
        'Τ': 528,
        'Υ': 594,
        'Φ': 831,
        'Χ': 624,
        'Ψ': 804,
        'Ϋ': 594,
        'έ': 509,
        'ή': 643,
        'ί': 312,
        'ΰ': 593,
        'β': 610,
        'γ': 526,
        'ε': 509,
        'ζ': 465,
        'η': 643,
        'θ': 638,
        'ι': 312,
        'κ': 518,
        'λ': 514,
        'ν': 526,
        'ξ': 465,
        'π': 616,
        'ρ': 619,
        'ς': 497,
        'σ': 639,
        'τ': 437,
        'υ': 593,
        'φ': 774,
        'χ': 509,
        'ψ': 745,
        'ω': 782,
        'ϊ': 312,
        'ϋ': 593,
        'ύ': 593,
        'ώ': 782,
        '‐': 440,
        '‑': 440,
        '–': 495,
        '—': 684,
        '―': 684,
        '‗': 500,
        '‘': 270,
        '’': 270,
        '‚': 270,
        '‛': 270,
        '“': 784,
        '”': 784,
        '„': 468,
        '†': 500,
        '‡': 500,
        '•': 308,
        '…': 1085,
        '‰': 1174,
        '′': 256,
        '″': 472,
        '‴': 689,
        '‵': 256,
        '‶': 472,
        '‷': 689,
        '‹': 312,
        '›': 312,
        '‼': 589,
        '‽': 433,
        '‾': 500,
        '⁄': 120,
        '⁺': 407,
        '⁻': 407,
        '⁼': 407,
        '⁽': 225,
        '⁾': 225,
        'ⁿ': 486,
        '₊': 407,
        '₋': 407,
        '₌': 407,
        '₍': 225,
        '₎': 225,
        'ₙ': 486,
        '₡': 599,
        '₣': 527,
        '₤': 600,
        '₥': 921,
        '₦': 625,
        '₨': 1093,
        '₩': 769,
        '₪': 754,
        '₫': 635,
        '₭': 614,
        '₮': 528,
        '₯': 1288,
        '₰': 950,
        '₲': 685,
        '₴': 576,
        '₵': 599,
        '₶': 576,
        '₷': 700,
        '₸': 528,
        '₻': 750,
        '₼': 683,
        '₾': 577,
        '₿': 620,
        '℃': 915,
        '℅': 825,
        '℉': 868,
        'ℓ': 385,
        '№': 1176,
        '℗': 806,
        '℡': 1022,
        '™': 903,
        '℮': 903,
        '⅛': 930,
        '⅜': 931,
        '⅝': 931,
        '⅞': 871,
        'Ⅶ': 1166,
        '∂': 587,
        '∈': 663,
        '∏': 708,
        '∑': 596,
        '√': 604,
        '∞': 679,
        '∧': 617,
        '∫': 531,
        '∮': 654,
        '≈': 600,
        '≒': 662,
        '◊': 600,
        '　': 0,
        '〞': 472,
    },
    glyphsByWidth: {
        268: 'ijìíîïĩīĭįıĵȷ',
        274: 'IÌÍÎÏĨĪĬĮİΙΪ',
        406: '²³¹⁰⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉',
        552: '+<=>^~¬±×÷−∕∙≠≤≥≦≧≮≯',
        556: 'EÈÉÊËĒĔĖĘĚΕΞ',
        575: '$0123456789¢£¤¥ƒ₢₧€₱₹₺₽',
        578: 'eèéêëēĕėęě',
        612: 'aàáâãäåāăąǻ',
        613: 'uµùúûüũūŭůűųάαμ∨',
        618: 'hnoðñòóôõöøĥħńņňŋōŏőǿδοό',
        667: 'AÀÁÂÃÄÅĀĂĄǺΑΔ₳∆',
        701: 'UÙÚÛÜŨŪŬŮŰŲ',
        743: 'OQÒÓÔÕÖØŌŎŐǾΘΟΩΩ',
        1000: '─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇█▉▊▋▌▍▎▏▓▔▕■□▲△▼▽◆◇○◎●◢◣◤◥★☆☉♀♂〾',
    },
    defaultWidth: 984,
    kerning: {
        '""': -56,
        '"\'': -57,
        '",': -179,
        '".': -179,
        '\'"': -56,
        '\'\'': -57,
        '\',': -179,
        '\'.': -179,
        '(j': 60,
        ',"': -160,
        ',\'': -160,
        ',1': -140,
        ',7': -41,
        ',9': -39,
        '."': -160,
        '.\'': -160,
        '.1': -140,
        '.7': -41,
        '.9': -39,
        '//': -120,
        '1,': -99,
        '1.': -99,
        '1:': -99,
        '1;': -99,
        '7,': -160,
        '7.': -160,
        '7:': -99,
        '7;': -99,
        ':1': -79,
        ':7': -59,
        ';1': -79,
        ';7': -59,
        'A"': -100,
        'A\'': -100,
        'AC': -20,
        'AG': -20,
        'AO': -20,
        'AQ': -20,
        'AT': -80,
        'AU': -10,
        'AV': -70,
        'AW': -39,
        'AY': -81,
        'Af': -20,
        'Al': -10,
        'At': -20,
        'Av': -20,
        'Ay': -20,
        'BC': -10,
        'BG': -10,
        'BO': -10,
        'BQ': -10,
        'BT': -40,
        'BV': -20,
        'BX': -20,
        'BY': -21,
        'D,': -59,
        'D.': -59,
        'DA': -20,
        'DT': -36,
        'DV': -30,
        'DW': -19,
        'DX': -20,
        'DY': -40,
        'DZ': -20,
        'Da': -39,
        'Ej': 19,
        'F,': -159,
        'F.': -159,
        'FA': -40,
        'Fa': -59,
        'Fh': 1,
        'Fk': 1,
        'GV': -11,
        'GY': -21,
        'JJ': 7,
        'KA': -19,
        'KC': -20,
        'KG': -20,
        'KO': -20,
        'KQ': -20,
        'KT': -19,
        'KU': -39,
        'KV': -39,
        'KW': -39,
        'KY': -40,
        'Kc': -39,
        'Kd': -39,
        'Ke': -39,
        'Kg': -39,
        'Kl': -39,
        'Ko': -39,
        'Kq': -39,
        'Ks': -19,
        'Kt': -10,
        'Ku': -40,
        'Kv': -60,
        'Kw': -40,
        'Ky': -60,
        'L"': -99,
        'L\'': -99,
        'LA': 20,
        'LC': -59,
        'LG': -59,
        'LO': -59,
        'LQ': -59,
        'LT': -79,
        'LU': -19,
        'LV': -79,
        'LW': -39,
        'LY': -100,
        'Lv': -41,
        'Lw': -21,
        'Ly': -41,
        'O,': -59,
        'O.': -59,
        'OA': -20,
        'OT': -36,
        'OV': -30,
        'OW': -19,
        'OX': -20,
        'OY': -40,
        'OZ': -20,
        'Oa': -39,
        'P,': -199,
        'P.': -199,
        'PA': -60,
        'PT': -29,
        'PV': -10,
        'PW': -10,
        'PX': -50,
        'PY': -20,
        'PZ': -39,
        'Pa': -60,
        'Q,': -59,
        'Q.': -59,
        'QA': -20,
        'QJ': 7,
        'QT': -36,
        'QV': -30,
        'QW': -19,
        'QX': -20,
        'QY': -40,
        'QZ': -20,
        'Qa': -39,
        'RC': -15,
        'RG': -15,
        'RO': -15,
        'RQ': -15,
        'RT': -40,
        'RU': -10,
        'RV': -21,
        'RW': -10,
        'RX': -29,
        'RY': -41,
        'Rc': -20,
        'Rd': -20,
        'Re': -20,
        'Rg': -20,
        'Ro': -20,
        'Rq': -20,
        'Rt': -20,
        'Ru': -10,
        'Rv': -10,
        'Rx': 20,
        'Ry': -10,
        'S,': -20,
        'S.': -20,
        'SS': -1,
        'ST': -1,
        'SV': -21,
        'SW': -10,
        'SY': -21,
        'St': -1,
        'Sv': -20,
        'Sw': -10,
        'Sx': -1,
        'Sy': -20,
        'T"': 2,
        'T\'': 2,
        'T,': -154,
        'T.': -154,
        'TA': -80,
        'TC': -20,
        'TG': -20,
        'TO': -20,
        'TQ': -20,
        'TS': -1,
        'Ta': -80,
        'Tc': -59,
        'Td': -59,
        'Te': -59,
        'Tg': -59,
        'Ti': -20,
        'Tj': -19,
        'Tm': -59,
        'Tn': -59,
        'To': -59,
        'Tp': -58,
        'Tq': -59,
        'Tr': -59,
        'Ts': -60,
        'Tt': 20,
        'Tu': -79,
        'Tv': -39,
        'Tw': -19,
        'Tx': -39,
        'Ty': -39,
        'Tz': -59,
        'UA': -10,
        'UX': -19,
        'Ux': -1,
        'V,': -140,
        'V.': -140,
        'V:': -41,
        'V;': -41,
        'VA': -70,
        'VC': -30,
        'VG': -30,
        'VO': -30,
        'VQ': -30,
        'VS': -10,
        'Va': -41,
        'Vc': -21,
        'Vd': -21,
        'Ve': -21,
        'Vg': -21,
        'Vh': 1,
        'Vk': 1,
        'Vo': -21,
        'Vq': -21,
        'Vs': -21,
        'Vv': -1,
        'Vy': -1,
        'W,': -79,
        'W.': -79,
        'W:': -39,
        'W;': -39,
        'WA': -40,
        'WC': -19,
        'WG': -19,
        'WO': -19,
        'WQ': -19,
        'Wa': -40,
        'Wc': -20,
        'Wd': -20,
        'We': -20,
        'Wg': -20,
        'Wo': -20,
        'Wq': -20,
        'Ws': -20,
        'XA': -19,
        'XC': -20,
        'XG': -20,
        'XO': -20,
        'XQ': -20,
        'XT': -19,
        'XU': -39,
        'XV': -39,
        'XW': -39,
        'XY': -40,
        'Xc': -39,
        'Xd': -39,
        'Xe': -39,
        'Xg': -39,
        'Xl': -39,
        'Xo': -39,
        'Xq': -39,
        'Xs': -19,
        'Xt': -10,
        'Xu': -40,
        'Xv': -60,
        'Xw': -40,
        'Xy': -60,
        'Y"': 1,
        'Y\'': 1,
        'Y,': -141,
        'Y.': -141,
        'Y:': -60,
        'Y;': -60,
        'YA': -81,
        'YC': -40,
        'YG': -40,
        'YO': -40,
        'YQ': -40,
        'YS': -1,
        'Ya': -101,
        'Yc': -60,
        'Yd': -60,
        'Ye': -60,
        'Yf': -1,
        'Yg': -60,
        'Yh': 1,
        'Yi': -19,
        'Yk': 1,
        'Ym': -41,
        'Yn': -41,
        'Yo': -60,
        'Yp': -40,
        'Yq': -60,
        'Yr': -41,
        'Ys': -61,
        'Yt': -1,
        'Yu': -40,
        'Yv': -40,
        'Yx': -41,
        'Yy': -40,
        'Yz': -41,
        'ZC': -20,
        'ZG': -20,
        'ZO': -20,
        'ZQ': -20,
        '[j': 80,
        'aT': -60,
        'aV': -21,
        'aY': -61,
        'av': -10,
        'aw': -10,
        'ay': -10,
        'b,': -40,
        'b.': -40,
        'bT': -59,
        'bV': -21,
        'bW': -20,
        'bX': -39,
        'bY': -60,
        'bv': -10,
        'bx': -20,
        'by': -10,
        'e,': -20,
        'e.': -20,
        'eT': -59,
        'eY': -40,
        'ej': 20,
        'f"': 3,
        'f\'': 3,
        'f)': 1,
        'f*': 61,
        'f,': -1,
        'f.': -1,
        'f?': 40,
        'fT': 40,
        'fV': 21,
        'fW': 21,
        'fX': 21,
        'fY': 1,
        'f]': 21,
        'fa': -29,
        'fc': -19,
        'fd': -19,
        'fe': -19,
        'ff': 1,
        'fg': -39,
        'fh': -19,
        'fi': -19,
        'fj': -19,
        'fk': -19,
        'fl': -19,
        'fo': -19,
        'fq': -19,
        'fs': -19,
        'ft': 1,
        'f}': 3,
        'hT': -58,
        'hY': -39,
        'hv': -10,
        'hy': -10,
        'i"': 2,
        'i\'': 2,
        'i)': 2,
        'i?': 3,
        'iT': -20,
        'i]': 41,
        'i}': 22,
        'jT': -20,
        'kT': -39,
        'kU': -1,
        'kW': -20,
        'ka': -20,
        'kc': -20,
        'kd': -20,
        'ke': -20,
        'kg': -20,
        'kl': -20,
        'ko': -20,
        'kq': -20,
        'ku': -10,
        'lf': -20,
        'lv': -19,
        'lw': -10,
        'ly': -19,
        'mT': -58,
        'mY': -39,
        'mv': -10,
        'my': -10,
        'nT': -58,
        'nY': -39,
        'nv': -10,
        'ny': -10,
        'o,': -40,
        'o.': -40,
        'oT': -59,
        'oV': -21,
        'oW': -20,
        'oX': -39,
        'oY': -60,
        'ov': -10,
        'ox': -20,
        'oy': -10,
        'p,': -40,
        'p.': -40,
        'pT': -59,
        'pV': -21,
        'pW': -20,
        'pX': -39,
        'pY': -60,
        'pv': -10,
        'px': -20,
        'py': -10,
        'qT': -19,
        'qY': -19,
        'qj': 20,
        'r"': 2,
        'r\'': 2,
        'r,': -90,
        'r.': -90,
        'ra': -49,
        'rc': -19,
        'rd': -19,
        're': -19,
        'rf': 1,
        'ro': -19,
        'rq': -19,
        'rt': 20,
        'sT': -59,
        'sV': -21,
        'sW': -20,
        'sX': -19,
        'sY': -60,
        'sv': -19,
        'sx': -10,
        'sy': -19,
        'tf': 1,
        'uT': -40,
        'uY': -19,
        'v,': -90,
        'v.': -90,
        'vT': -39,
        'vX': -39,
        'va': -35,
        'vc': -10,
        'vd': -10,
        've': -10,
        'vo': -10,
        'vq': -10,
        'w,': -50,
        'w.': -50,
        'wT': -19,
        'wX': -39,
        'wa': -30,
        'xT': -39,
        'xU': -1,
        'xW': -20,
        'xa': -20,
        'xc': -20,
        'xd': -20,
        'xe': -20,
        'xg': -20,
        'xl': -20,
        'xo': -20,
        'xq': -20,
        'xu': -10,
        'y,': -90,
        'y.': -90,
        'yT': -39,
        'yX': -39,
        'ya': -35,
        'yc': -10,
        'yd': -10,
        'ye': -10,
        'yo': -10,
        'yq': -10,
        'zT': -59,
        '{h': 2,
        '{j': 79,
        '{k': 2,
    },
};
